import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_SUPPLIER } from '../../../constants/eInvoicePermissions';
import { PURCHASE_MODULE_KEY } from '../../settings/constants/roleModules';

export default function SupplierAccessLayout() {
  const title = useRoleModuleLabel(PURCHASE_MODULE_KEY);

  return <EInvoiceAccessLayout permission={READ_SUPPLIER} title={title} />;
}
